export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ripeti operazione"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Storia delle operazioni"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista dei conti"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore sconosciuto"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista dei token"])}
}